import React from 'react';
import { useTranslation } from 'react-i18next';
import { useVivliConfigContext } from '@vivli/core/infrastructure/context';

export const DefaultFullDataPackageListComponent = () => {
    const { t } = useTranslation();
    const vivliConfig = useVivliConfigContext();
    return (
        <ul>
            {vivliConfig?.ipdFileTypes
                ?.filter((x) => x.includeCt)
                .map((x) => (
                    <li>{t(x.dropDownDisplayName)}</li>
                ))}
        </ul>
    );
};
